import { useContext, useRef, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { validateFile } from "../../utils/application-helper";
import VideoPlayer from "../components/VideoPlayer";
import axiosHttp from "../config/axios.interceptor";
import axios from "axios";
import {
  base_url,
  dataURItoBlob,
  errorResponseMessage,
  httpHeaderConfig,
} from "./const.prop";
import Delete from "./Delete";
import { AuthContext } from "../contexts/AuthContext";
import LinkPreviewCard from "../components/LinkPreviewCard";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const AddReels = ({ data = null }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [videoSrc, setVideoSrc] = useState(data ? data?.url : null);
  const [previewUrl, setPreviewUrl] = useState(data ? data.url : null);
  const [videoBlob, setVideoBlob] = useState(null);
  const [caption, setCaption] = useState(data ? data?.description : null);
  const videoWrapperStyle = { width: "100%", height: "300px" };
  const [categoryId, setCategoryId] = useState(
    data?.skillCategoryId ? data?.skillCategoryId : ""
  );
  const { categoryList } = useSelector((state) => state.utilData);
  const inputRef = useRef(null);
  const triggerFileSelectHandler = () => inputRef.current.click();
  const fileChangeHandler = () => {
    const file = inputRef.current.files[0];
    const validationRes = validateFile(file, "video");
    const fileReader = new FileReader();
    fileReader.onload = () => setVideoBlob(fileReader.result);
    fileReader.readAsDataURL(file);
    if (validationRes.errors.length) {
      appContext.updateNotificationState({
        type: "error",
        message: validationRes.errors[0],
        show: true,
      });
      return;
    }
    setVideoSrc(URL.createObjectURL(file));
  };
  // const postSubmit = (savedResponse) => {
  //   if (savedResponse && savedResponse.status !== 200) {
  //     appContext.updateNotificationState({
  //       type: "error",
  //       message: errorResponseMessage(error),
  //       show: true,
  //     });
  //     appContext.updateLoaderState(false);
  //   }
  //   const savedUrl = savedResponse ? savedResponse.data.tempPath : data?.url;
  //   if (data?.id) {
  //     axiosHttp
  //       .post(`post-data/${data.id}`, {
  //         type: "reels",
  //         text: caption,
  //         url: savedUrl,
  //       })
  //       .then((postResponse) => {
  //         if (postResponse.status === 201) {
  //           appContext.updateLoaderState(false);
  //           appContext.updateModalState();
  //         }
  //       })
  //       .catch((error) => {
  //         if (error.response.status === 429) {
  //           appContext.updateNotificationState({
  //             show: true,
  //             message: errorResponseMessage(error),
  //             type: "error",
  //           });
  //           authContext.logout();
  //         }
  //         appContext.updateNotificationState({
  //           type: "error",
  //           message: errorResponseMessage(error),
  //           show: true,
  //         });
  //         appContext.updateLoaderState(false);
  //       });
  //   } else {
  //     axiosHttp
  //       .post("post-data", {
  //         type: "reels",
  //         text: caption,
  //         url: savedUrl,
  //       })
  //       .then((postResponse) => {
  //         if (postResponse.status === 201) {
  //           appContext.updateLoaderState(false);
  //           appContext.updateModalState();
  //         }
  //       })
  //       .catch((error) => {
  //         if (error.response.status === 429) {
  //           appContext.updateNotificationState({
  //             show: true,
  //             message: errorResponseMessage(error),
  //             type: "error",
  //           });
  //           authContext.logout();
  //         }
  //         appContext.updateNotificationState({
  //           type: "error",
  //           message: errorResponseMessage(error),
  //           show: true,
  //         });
  //         appContext.updateLoaderState(false);
  //       });
  //   }
  // };
  const postHandler = () => {
    appContext.updateLoaderState(true);
    const formData = new FormData();
    if (videoBlob === null) {
      postSubmit();
    }
    formData.append("image", dataURItoBlob(videoBlob));
    axios
      .post(base_url + "upload-image", formData, {
        headers: {
          ...httpHeaderConfig,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((savedResponse) => postSubmit(savedResponse))
      .catch((error) => {
        console.log(error);
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
          appContext.updateLoaderState(false);
          return;
        }
        appContext.updateNotificationState({
          type: "error",
          message: errorResponseMessage(error),
          show: true,
        });
        appContext.updateLoaderState(false);
      });
  };
  const reSetVideo = () => setVideoSrc(null);

  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([\w\-]+)/;
  const facebookVideoRegex =
    /(?:https?:\/\/)?(?:www.|web.|m.)?(facebook|fb).(com|watch)\/(?:video.php\?v=\d+|(\S+)|photo.php\?v=\d+|\?v=\d+)|\S+\/videos\/((\S+)\/(\d+)|(\d+))\/?/;
  const facebookReelRegex =
    /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:watch\/)?(?:\?v=)?(\d+)/;

  const isValidUrl = (videoLink) => {
    if (
      videoLink?.includes("https://fb") ||
      videoLink?.includes("facebook.com")
    ) {
      if (facebookReelRegex.test(videoLink)) {
        return true;
      } else if (facebookVideoRegex.test(videoLink)) {
        return true;
      } else {
        return false;
      }
    } else if (videoLink.includes("instagram.com")) {
      return true;
    } else if (youtubeRegex.test(videoLink)) {
      return true;
    } else if (videoLink.includes("linkedin.com")) {
      return true;
    } else {
      return false;
    }
  };

  const postSubmit = () => {
    if (isValidUrl(videoSrc)) {
      if (data?.id) {
        axiosHttp
          .post(`post-data/${data.id}`, {
            type: "reels",
            text: caption,
            url: videoSrc,
            skillCategoryId: categoryId,
          })
          .then((postResponse) => {
            if (postResponse.status === 201) {
              appContext.updateLoaderState(false);
              appContext.updateModalState();
            }
          })
          .catch((error) => {
            if (error.response.status === 429) {
              appContext.updateNotificationState({
                show: true,
                message: errorResponseMessage(error),
                type: "error",
              });
              authContext.logout();
            }
            if (error.response?.status >= 500) {
              appContext.updateNotificationState({
                show: true,
                message: "Something went wrong, please try again later.",
                type: "error",
              });
              appContext.updateLoaderState(false);
              return;
            }
            appContext.updateNotificationState({
              type: "error",
              message: errorResponseMessage(error),
              show: true,
            });
            appContext.updateLoaderState(false);
          });
      } else {
        axiosHttp
          .post("post-data", {
            type: "reels",
            text: caption,
            url: videoSrc,
            skillCategoryId: categoryId,
          })
          .then((postResponse) => {
            if (postResponse.status === 201) {
              appContext.updateLoaderState(false);
              appContext.updateModalState();
            }
          })
          .catch((error) => {
            if (error.response.status === 429) {
              appContext.updateNotificationState({
                show: true,
                message: errorResponseMessage(error),
                type: "error",
              });
              authContext.logout();
            }
            if (error.response?.status >= 500) {
              appContext.updateNotificationState({
                show: true,
                message: "Something went wrong, please try again later.",
                type: "error",
              });
              appContext.updateLoaderState(false);
              return;
            }
            appContext.updateNotificationState({
              type: "error",
              message: errorResponseMessage(error),
              show: true,
            });
            appContext.updateLoaderState(false);
          });
      }
    } else {
      toast.error("Please provide a valid url");
    }
  };

  const handleClose = () => {
    setPreviewUrl(null);
  };

  return (
    <>
      <div className="modal-body">
        {/* {!videoSrc && (
          <div
            className="card frame cursor-pointer d-flex justify-content-center"
            onClick={triggerFileSelectHandler}
          >
            <p className="file text-center img-txt cursor-pointer">
              Click to upload a reel
            </p>
          </div>
        )}
        {videoSrc && (
          <div className="modal-video-container video-wrapper">
            <Delete clickHandler={reSetVideo} />
            <VideoPlayer wrapper={videoWrapperStyle} videoSrc={videoSrc} />
          </div>
        )} */}
        <input
          type="text"
          className="form-control w-100 form-video mt-4"
          placeholder="Add a video url...."
          onChange={(e) => {
            setVideoSrc(e.target.value);
            setPreviewUrl(e.target.value);
          }}
          value={videoSrc}
        />

        <input
          type="text"
          className="form-control w-100 form-video mt-4"
          placeholder="Add a Caption...."
          onChange={(e) => setCaption(e.target.value)}
          value={caption}
        />
        <input
          onChange={fileChangeHandler}
          type="file"
          className="visible-hidden"
          ref={inputRef}
        />
        <div className="form-group category-select ">
          <select
            className="form-control custom-select"
            onChange={(e) => setCategoryId(e.target.value)}
            disabled={
              data?.skillCategoryId === "680c89f84f3447f6da04284f"
                ? true
                : false
            }
            value={categoryId}
          >
            <option value="">Select category</option>
            {categoryList.map((item) => {
              return <option value={item?._id}>{item?.name}</option>;
            })}
          </select>
        </div>
        {/* {previewUrl && (
          <LinkPreviewCard
            url={previewUrl}
            handleClose={handleClose}
            isReel={true}
          />
        )} */}
        <p>
          <b>Note: </b>Please paste the links of videos/reels from youtube,
          facebook or instagram
        </p>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={!videoSrc || appContext.loaderState || categoryId === ""}
          className="btn btn-outline-primary modal-btn"
          // onClick={postHandler}
          onClick={postSubmit}
        >
          Done
        </button>
      </div>
    </>
  );
};

export default AddReels;
